"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var winston_1 = tslib_1.__importDefault(require("winston"));
exports.level = process.env.LOG_LEVEL || 'warn';
exports.logger = winston_1.default.createLogger({
    level: exports.level,
    format: winston_1.default.format.json(),
    transports: [
        new winston_1.default.transports.Console({
            // This `log` method is not optimal for NodeJS since it doesn't use
            // `console._stdout` and `console._stderr`.
            log: function (info, callback) {
                var MESSAGE = Symbol.for('message');
                var LEVEL = Symbol.for('level');
                if (this.stderrLevels[info[LEVEL]]) {
                    if (Object.keys(info.metadata).length) {
                        console.error(info[MESSAGE], info.metadata);
                    }
                    else {
                        console.error(info[MESSAGE]);
                    }
                    if (callback) {
                        callback();
                    }
                    return undefined;
                }
                if (Object.keys(info.metadata).length) {
                    console.log(info[MESSAGE], info.metadata);
                }
                else {
                    console.log(info[MESSAGE]);
                }
                if (callback) {
                    callback();
                }
                return undefined;
            },
            format: winston_1.default.format.combine(
            //Winston.format.colorize(),
            winston_1.default.format.timestamp({
                format: 'YYYY-MM-DD hh:mm:ss.SSS A',
            }), winston_1.default.format.metadata({
                fillExcept: ['message', 'label', 'level', 'timestamp'],
            }), winston_1.default.format.printf(function (info) {
                var label = info.label ? "[" + info.label + "]" : '';
                var level = info.level ? "[" + info.level + "]" : '';
                return [info.timestamp, label, level, info.message].filter(function (item) { return Boolean(item); }).join(' ');
            })),
        }),
    ],
});
exports.default = exports.logger;
//# sourceMappingURL=logger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/logger.js
// module id = MoWs
// module chunks = 0